export const ForbiddenIcon = () => {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.5624 12.8498C99.1209 11.5037 125.797 35.9922 127.15 67.5504C128.502 99.1087 104.02 125.79 72.4618 127.149C40.8946 128.509 14.2035 104.017 12.8503 72.4498C11.4972 40.882 35.9946 14.1963 67.5624 12.8498Z"
        fill="#5BB5B3"
      />
      <path
        d="M39.1143 114.232C14.5737 97.1105 8.66056 63.2847 25.9372 38.8532C43.2137 14.4215 77.0764 8.72285 101.398 26.1539C125.502 43.4295 131.14 76.9243 114.017 101.138C96.8944 125.351 63.436 131.201 39.1143 114.232Z"
        fill="#DFECEF"
      />
      <path
        d="M101.398 26.1562C125.502 43.4319 131.139 76.9266 114.017 101.14C96.8942 125.354 63.4358 131.203 39.1141 114.234C39.835 114.022 42.2057 115.357 43.0372 115.692C56.031 120.924 67.0803 119.202 80.1406 114.64C81.9586 114.005 83.818 113.421 85.5779 112.638C94.8958 108.492 104.648 99.2173 109.655 90.2324C119.603 72.3801 119.233 52.3442 108.435 35.173C107.696 33.9983 106.925 32.8442 106.061 31.7577C105.085 30.5317 101.707 27.3789 101.398 26.1562Z"
        fill="#B3DADB"
      />
      <path
        d="M48.6474 50.18C55.8599 49.5832 62.1846 54.9601 62.7563 62.1744C63.3283 69.389 57.9297 75.6951 50.7134 76.2423C43.532 76.7868 37.2632 71.42 36.6938 64.2407C36.1247 57.0611 41.4698 50.7737 48.6474 50.18Z"
        fill="#5BB5B3"
      />
      <path
        d="M49.1962 53.3642C58.0245 52.7985 62.6523 63.0853 57.1513 69.6047C56.3796 64.5125 49.4838 64.1807 48.7584 68.3498C47.6198 69.8871 48.4699 71.5953 49.4494 72.9365C36.6576 72.1191 36.9042 54.6223 49.1962 53.3642Z"
        fill="#F5F5F9"
      />
      <path
        d="M89.15 50.1845C96.3036 49.503 102.655 54.751 103.334 61.9049C104.012 69.0585 98.7619 75.4077 91.608 76.0838C84.4578 76.7595 78.1129 71.5127 77.4343 64.3626C76.7559 57.2127 82.0005 50.8658 89.15 50.1845Z"
        fill="#5BB5B3"
      />
      <path
        d="M89.2402 53.3628C98.0743 52.5325 102.931 61.7599 98.2188 68.9782C96.7013 64.5537 91.3215 64.0751 89.544 68.3484C88.9124 70.1881 89.3694 71.485 90.5267 72.9351C78.38 72.9776 76.9597 55.2121 89.2402 53.3628Z"
        fill="#F5F5F9"
      />
      <path
        d="M68.3151 87.3237C76.1347 87.2465 83.7519 88.4772 90.9055 91.7303C93.0129 92.6888 95.2231 94.747 92.0403 95.7259C91.5628 95.6106 91.048 95.4129 90.5853 95.2369C84.5635 92.9472 78.2854 91.9936 71.8651 91.5731C65.969 91.561 60.2028 92.0017 54.4559 93.4602C52.2301 94.025 50.108 94.9323 47.8951 95.5256C46.5395 95.7285 45.2207 93.5536 48.3333 92.0407C55.419 88.5972 60.7557 87.8321 68.3151 87.3237Z"
        fill="#5BB5B3"
      />
      <path
        d="M85.2556 34.5085C87.0944 34.425 91.9624 42.0829 101.488 42.4965C102.099 42.5228 103.854 42.4205 104.332 42.6344C105.898 43.335 105.744 45.1479 104.077 45.7583C97.243 46.3063 89.892 43.324 85.2284 38.3631C84.1006 37.1633 82.7815 35.203 85.2556 34.5085Z"
        fill="#5BB5B3"
      />
      <path
        d="M54.4765 34.5102C57.8987 34.3052 55.1607 37.9933 54.1652 39.0564C49.1097 44.4564 43.571 45.5496 36.6593 45.76C34.7271 45.351 33.8947 42.2985 37.7218 42.4479C43.0805 42.6563 48.5692 40.4423 52.1434 36.4152C52.8701 35.5966 53.3999 34.766 54.4765 34.5102Z"
        fill="#5BB5B3"
      />
      <path
        d="M26.5049 60.6724C27.6501 60.5848 29.0089 61.1866 28.895 62.4419C28.712 64.4585 28.2961 70.7753 26.5049 71.8341C24.8276 71.9321 23.7947 71.3366 23.9572 69.5001C24.1454 67.3725 24.3066 61.2881 26.5049 60.6724Z"
        fill="#5BB5B3"
      />
      <path
        d="M26.0983 75.184C26.8171 75.1464 27.6241 75.3465 27.9736 76.0532C28.3207 76.7558 29.4456 82.2911 29.2199 82.8671C28.9531 83.5481 28.4242 83.91 27.7727 84.1718C26.6697 84.2334 25.8191 83.7776 25.5806 82.6616C25.0751 80.2973 23.2451 75.9609 26.0983 75.184Z"
        fill="#5BB5B3"
      />
    </svg>
  );
};
